import React from 'react';
import whatsappIcon from '@/assets/whatsapp-icon.png';

const PHONE_NUMBER = '972555072296'; // 0555072296 with Israel country code
const DEFAULT_MESSAGE = ' שלום, אני נמצא באתר ואשמח לקבל עזרה מנציג ';
const WHATSAPP_URL = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

const FloatingWhatsAppButton: React.FC = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="צור קשר בוואטסאפ"
      className="fixed z-50 transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-full
        /* Mobile: bottom-left, above bottom nav (70px nav + 16px gap) */
        bottom-[86px] left-4
        /* Desktop: bottom-left with text label */
        md:bottom-6 md:left-6"
    >
      {/* Mobile: Icon only */}
      <div className="md:hidden w-14 h-14 rounded-full shadow-lg flex items-center justify-center bg-white">
        <img 
          src={whatsappIcon} 
          alt="WhatsApp" 
          className="w-12 h-12 object-contain"
        />
      </div>

      {/* Desktop: Icon with text */}
      <div className="hidden md:flex items-center gap-2 bg-[#25D366] hover:bg-[#20BD5A] text-white px-4 py-3 rounded-full shadow-lg">
        <img 
          src={whatsappIcon} 
          alt="" 
          className="w-8 h-8 object-contain"
        />
        <span className="font-medium text-sm whitespace-nowrap">צריכים עזרה?</span>
      </div>
    </a>
  );
};

export default FloatingWhatsAppButton;
